import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Button,
  Box,
  Typography,
  Select,
  MenuItem,
  Menu,
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PreviewIcon from "@mui/icons-material/Preview";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  findFundAbbById,
  findFundById,
  TABLE_CROSS_TRADE as tableHeader,
} from "../../../../component/Methods";
import { useSelector } from "react-redux";
import { selectFunds } from "../../../../Redux/Reducers/fundsSlice";
import CrossingTradesTable from "./components/CrossingTradesTable";
import Loader from "../../../../component/Loader";
import CrossingTradeRebalancer from "../../Popup/CrossingTradeRebalancer";
import CrossingTradesSkeleton from "../../Skeletons/CrossingTradesSkeleton";
import ReviewDataDialogue from "../../Popup/ReviewDataDialogue";
import ValidatedData from "../../Popup/ValidatedData";
import { selectCrossingLoader, selectAllTrades, selectActiveRequests } from "../../../../Redux/Reducers/selectors";

const FundStep3 = ({ setCurrentStep, onPrevious }) => {
  const funds = useSelector(selectFunds);
  const crossingLoader = useSelector(selectCrossingLoader);
  const AllTrades = useSelector(selectAllTrades);
  const activeRequests = useSelector(selectActiveRequests);
  const [combinedOrders, setCombinedOrders] = useState([]);
  const [selectedFund, setSelectedFund] = useState("All");
  const [viewReviewData, setViewReviewData] = useState(false);
  const [viewValidateData, setViewValidateData] = useState(false);
  const [openCrossPopup, setOpenCrossPopup] = useState(false);
  const [contextMenuAnchor, setContextMenuAnchor] = useState(null);
  useEffect(() => {
    if (
      AllTrades &&
      Array.isArray(AllTrades?.realOrders) &&
      Array.isArray(AllTrades?.crossingOrders)
    ) {
      const combined = [...AllTrades.realOrders, ...AllTrades.crossingOrders];
      setCombinedOrders(combined);
    } else {
      setCombinedOrders([]);
    }
  }, [AllTrades]);

  const fundOptions = [
    { id: "All", abbreviation: "All" },
    ...combinedOrders
      .map((order) => {
        const fundAbbreviation = findFundAbbById(order?.fund, funds);
        return { id: order?.fund, abbreviation: fundAbbreviation };
      })
      .filter(
        (value, index, self) =>
          index ===
          self.findIndex(
            (t) => t.id === value.id && t.abbreviation === value.abbreviation
          )
      ),
  ];

  const handleFundChange = (event) => {
    setSelectedFund(event.target.value);
  };


  const filteredOrders =
    selectedFund === "All"
      ? combinedOrders
      : combinedOrders.filter((order) => order.fund == selectedFund);

  const onNext = () => {
    setCurrentStep((prev) => prev + 1);
  };
  const onClickReviewData = () => {
    setViewReviewData(true);
  };
  const onClickSingleLineData = () => {
    setOpenCrossPopup(true);
  };
  const onClickValidateData = () => {
    setViewValidateData(true);
  };

  const handleContextMenuOpen = (event) => {
    setContextMenuAnchor(event.currentTarget);
  };

  const handleContextMenuClose = () => {
    setContextMenuAnchor(null);
  };

  const handleContextMenuAction = (action) => {
    handleContextMenuClose();
    switch (action) {
      case 'singleLine':
        onClickSingleLineData();
        break;
      case 'signalSet':
        onClickReviewData();
        break;
      case 'validate':
        onClickValidateData();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Container disableGutters maxWidth="100%" sx={{ marginTop: 2 }}>
        {/* Check if we're loading crossing trades data */}
        {activeRequests.includes("create_rebalancer_crossing_orders") ? (
          <CrossingTradesSkeleton />
        ) : crossingLoader ? (
          <Loader mTrue={false} />
        ) : (
          <Grid container spacing={2} alignItems="center">
            <Grid size={{ xs: 12 }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    width: "44%",
                  }}
                >
                  <Box
                    sx={{
                      marginBottom: 1,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold !important",
                        fontSize: "20px !important",
                      }}
                    >
                      Crossing Trades
                    </Typography>
                    <Select
                      value={selectedFund}
                      onChange={handleFundChange}
                      sx={{ marginLeft: 2 }}
                      size="small"
                    >
                      {fundOptions.map((fund) => (
                        <MenuItem key={fund.id} value={fund.id}>
                          {fund.abbreviation}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </div>

                {filteredOrders && filteredOrders.length > 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1,
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      onClick={handleContextMenuOpen}
                      sx={{
                        backgroundColor: "#525050",
                        border: "1px solid #525050",
                        "&:hover": {
                          backgroundColor: "#525050"
                        },
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Button
                      variant="contained"
                      endIcon={<ArrowForwardIcon />}
                      onClick={onNext}
                      sx={{ width: "150px", height: "40px" }}
                    >
                      Next
                    </Button>
                  </Box>
                ) : null}
              </div>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "45%",
                  justifyContent: "space-between",
                }}
              >
                {filteredOrders ? (
                  <CrossingTradesTable
                    crossingTrades={filteredOrders}
                    tableHeader={tableHeader?.slice(1)}

                  />
                ) : (
                  <p>No data available</p>
                )}
              </div>
            </Grid>
          </Grid>
        )}
      </Container>
      <CrossingTradeRebalancer
        title="Orders"
        openCrossPopup={openCrossPopup}
        setOpenCrossPopup={setOpenCrossPopup}
        setCurrentStep={setCurrentStep}
        showNext={false}
      />
      <ReviewDataDialogue
        title="Review Data"
        open={viewReviewData}
        onClose={() => setViewReviewData(false)}
      />
      <ValidatedData
        title="Validate Crossing Trades"
        open={viewValidateData}
        onClose={() => setViewValidateData(false)}
      />

      {/* Context Menu */}
      {/* make it dark in dark mode */}
      <Menu
        anchorEl={contextMenuAnchor}
        open={Boolean(contextMenuAnchor)}
        onClose={handleContextMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => handleContextMenuAction('singleLine')}>
          <ListItemIcon>
            <VisibilityIcon fontSize="small" sx={{ color: "#1976d2" }} />
          </ListItemIcon>
          <ListItemText>View Single Line Orders</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleContextMenuAction('signalSet')}>
          <ListItemIcon>
            <SignalCellularAltIcon fontSize="small" sx={{ color: "#2e7d32" }} />
          </ListItemIcon>
          <ListItemText>View Signal Set</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleContextMenuAction('validate')}>
          <ListItemIcon>
            <CheckCircleIcon fontSize="small" sx={{ color: "#ed6c02" }} />
          </ListItemIcon>
          <ListItemText>Validate</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default FundStep3;
